export enum FileStatusEnum {
  UploadPending = 0,
  PendingSetUp = 1,
  Processing = 2,
  Processed = 3,
  Error = 4,
  Queue = 5,
  Complete = 6
}
